jQuery(document).ready(function ($) {
    let isPopupClosed = false;
    let prevValue = 500;
    const qtyInput = $('[data-product-qty]');
    const popup = $('[data-bulk-order-popup]').length ? $('[data-bulk-order-popup]') : $('[data-bulk-product-popup]');
    $('[data-product-qty]').on('change input', function () {
        showPopup(false);
    });
    $('[data-order-popup-close]').on('click', closePopup)
    $('#extra').on('change', changeExtraQty)

    $(document).on('click', function (e) {
        if ($(e.target).hasClass('c-bulk-popup__overlay') && popup.hasClass('is-open')) {
            closePopup();
        }
    })
    $('[data-add-ons-button]').on('click', function () {
        isPopupClosed = false;
    })
    if ($('[data-qty-minus]').length) {
        $('[data-qty-minus]').on('click', function () {
            showPopup(true);
        })
    }

    function showPopup(minus) {
        if (!isPopupClosed) {
            const bulkOrderPopup = $('[data-bulk-order-popup]');
            const bulkProductPopup = $('[data-bulk-product-popup]');
            if (qtyInput.val() > 25 && bulkOrderPopup.length) {
                bulkOrderPopup.addClass('is-open');
            }
            if (bulkProductPopup.length) {
                setTimeout(function () {
                    if (!minus) {
                        if (qtyInput.val() < 500) {
                            bulkProductPopup.addClass('is-open');
                        }
                    } else {
                        if (Number(qtyInput.val()) === 500) {
                            bulkProductPopup.addClass('is-open');
                        }
                    }
                }, 1000)
            }
        }
    }

    function closePopup() {
        if ($('[data-bulk-product-popup]').length && qtyInput.val() < 500) {
            if ($('[data-bulk-product-popup]').hasClass('is-open')) {
                qtyInput.val(500);
                setPrice(500);
                $('[data-minus-btn]').attr('disabled', 'disabled')
            }
        }

        if (popup.length) {
            popup.removeClass('is-open');
        }
        isPopupClosed = true;
    }

    function changeExtraQty() {
        const qtyInput = $('[data-product-qty]');
        const qtyButtonVal = qtyInput.val();
        let $totalInp = $('[name="calcTotal"]');
        let $recommendInp = $('[name="calcRecommend"]');
        if ($(this).is(':checked')) {
            const newValue = prevValue;
            if ($totalInp.val().length > 0) {
                let total = Number($totalInp.val()) + Math.ceil(Number($totalInp.val()) / 100 * 10);
                total = Math.ceil(total / 5) * 5;
                $recommendInp.val(total);
                total = total >= 500 ? Math.ceil(total / 5) * 5 : 500;
                qtyInput.val(total);
                setPrice(total);
            }
        } else {
            prevValue = Number(qtyButtonVal);
            if ($totalInp.val().length > 0) {
                const total = $totalInp.val() >= 500 ? Math.ceil($totalInp.val() / 5) * 5 : 500;
                qtyInput.val(total);
                setPrice(total);
                $recommendInp.val(Math.ceil($totalInp.val() / 5) * 5)
            }
        }
    }

    function setPrice(value) {
        const priceElement = $('[data-product-price]');
        let currencySymbol = Array.from(priceElement.attr('data-product-price'))[0];
        const oldPriceElement = $('[data-product-old-price]');
        const priceValue = Number(priceElement.attr('data-product-price').replace(currencySymbol, '').replace(' ','').replace(',',''));
        const oldPriceValue = Number(oldPriceElement.attr('data-product-old-price').replace(currencySymbol, '').replace(' ','').replace(',',''));
        priceElement.text(currencySymbol + (value * priceValue).toFixed(2));
        if (Number(oldPriceValue) > 0) {
            oldPriceElement.text(currencySymbol + (value * oldPriceValue).toFixed(2));
        }
    }

    const bulkQtyInputChange = () => {
        let bulkQtyInput = $('.s-main-product__c-quantity--bulk input.c-quantity__input, .s-cart-item__c-quantity.c-quantity--bulk input.c-quantity__input');
        if ( bulkQtyInput.length <= 0 ) {
            return false;
        }
        bulkQtyInput.on('change', (event) => {
            event.preventDefault();

            const inputMin = parseInt(bulkQtyInput.attr('min')),
                inputVal = parseInt(bulkQtyInput.val());

            if ( inputVal < inputMin ) {
                bulkQtyInput.val(inputMin);
                setPrice(inputMin);
            }
            else {
                bulkQtyInput.val(inputVal);
                setPrice(inputVal);
            }
        });
    };
    bulkQtyInputChange();
});